import URI from "urijs";

/**
 * url地址拼接
 * @param root    根地址，可包含域名
 * @param path    多个拼接地址
 * @returns {string}
 */
export function joinPath(root, ...path) {
  return joinPathObj(root, ...path).toString();
}

/**
 * url地址拼接
 * @param root    根地址，可包含域名
 * @param path    多个拼接地址
 * @returns {URI}
 */
export function joinPathObj(root, ...path) {
  return URI.joinPaths(root, ...path).origin(root);
}

export function getAllUrlQuery() {
  const uri = URI(window.location.href);
  const query = uri.query(true);
  const fragmentUrl = uri.fragment();
  if (fragmentUrl) {
    const subUri = URI(fragmentUrl);
    const subQuery = subUri.query(true);
    Object.assign(query, subQuery);
  }
  return query;
}
